<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">EDITAR EXTRA</h1>
    </section>

    <form [formGroup]="editExtraForm" (ngSubmit)="saveChanges(editExtraForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="name">
              <mat-error *ngIf="editExtraForm.controls['name'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editExtraForm.controls['name'].hasError('cannotContainSpace')">
                El nombre no puede ser un espacio en blanco
            </mat-error>
            <mat-error *ngIf="editExtraForm.controls['name'].hasError('pattern')">
              Formato incorrecto, debe comenzar debe comenzar con mayúscula y sin espacios, ej: Ensaladas,Postres...
            </mat-error>
            <mat-hint>Debe comenzar debe comenzar con mayúscula y sin espacios</mat-hint>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Precio</mat-label>
              <input type="number" matInput formControlName="price">
              <mat-error *ngIf="editExtraForm.controls['price'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editExtraForm.controls['price'].hasError('min')">
                El precio debe ser mayor a 0.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button type="submit" [disabled]="!editExtraForm.valid" mat-raised-button class="save-changes">GUARDAR CAMBIOS</button>
        <button routerLink="/additionals" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>